<script lang="ts" setup>
import { nextTick, onMounted, ref } from 'vue';

const wrapperRef = ref<HTMLDivElement>();

onMounted(async () => {
  // 後からウィジェットを発火させる
  // ref: https://developers.facebook.com/docs/javascript/reference/FB.init/v19.0
  await nextTick();

  // 描画に失敗したときにページ全体がエラーになってしまうので、try/catchを挟む
  try {
    if (window.FB) {
      window.FB.XFBML.parse(wrapperRef.value);
    }
  } catch (e) {
    console.warn('FB.XFBML.parse failed:', e);
  }
});
</script>

<template>
  <ClientOnly>
    <div
      ref="wrapperRef"
      class="text-center mb-10 pb-10 border-b border-gray-400"
    >
      <div
        class="fb-page"
        data-href="https://www.facebook.com/dietplusjp/"
        data-small-header="true"
        data-adapt-container-width="true"
        data-hide-cover="true"
        data-show-facepile="true"
      >
        <blockquote
          cite="https://www.facebook.com/dietplusjp/"
          class="fb-xfbml-parse-ignore"
        >
          <a href="https://www.facebook.com/dietplusjp/">ダイエットプラス</a>
        </blockquote>
      </div>
    </div>
  </ClientOnly>
</template>
